/* tslint:disable */

declare var Object: any;
export interface TopicInterface {
  "sourceObjectTypeId": number;
  "sourceObjectId": number;
  "name"?: string;
  "displayName"?: string;
  "description"?: string;
  "code": string;
  "parentId"?: number;
  "categoryId": number;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class Topic implements TopicInterface {
  "sourceObjectTypeId": number;
  "sourceObjectId": number;
  "name": string;
  "displayName": string;
  "description": string;
  "code": string;
  "parentId": number;
  "categoryId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: TopicInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Topic`.
   */
  public static getModelName() {
    return "Topic";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Topic for dynamic purposes.
  **/
  public static factory(data: TopicInterface): Topic{
    return new Topic(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Topic',
      plural: 'Topics',
      path: 'Topics',
      idName: 'id',
      properties: {
        "sourceObjectTypeId": {
          name: 'sourceObjectTypeId',
          type: 'number'
        },
        "sourceObjectId": {
          name: 'sourceObjectId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "parentId": {
          name: 'parentId',
          type: 'number'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
